<template>
  <div class="columns">
        <div class="column is-12-mobile is-10-desktop is-10-widescreen">
            <div class="level">
              <div class="level-left">
                <div class="title">Your notifications <span class="is-size-6 button is-white has-text-right preloader" :class="{'is-loading': is_loading}"></span></div>
              </div>
            </div>
            <span ref="sms_info" class="is-hidden">
                <!--
                Dont delete this tag. it is here to trick vuejs - because we're generating forms dynamically,
                it wont register any refs created dynamically. So this registers the ref at runtime so once
                referenced after an update to DOM vue then knows about it.
                -->
            </span>
            <div class="is-6" v-if="!is_loading">
                <!-- email notification settings -->
                <form novalidate @submit.prevent="submitForm">
                    <div v-for="(parent, index) in notifications_settings" class="margin-bottom-20">
                        <div v-for="(tree, branch) in parent">
                            <div v-for="(node, value) in tree">

                                <!--titles and subtitles -->
                                <div v-if="isPermitted">
                                    <h6 v-if="value === 'title'" class="subtitle is-6 has-text-weight-bold margin-top-25">{{node}}</h6>
                                    <h6 v-if="value === 'sub_title'" class="subtitle is-7 margin-top-10 margin-bottom-10" v-html="`${node}`"></h6>
                                </div>
                                <div v-else>
                                    <div v-if="branch !== 'star_ratings_settings'">
                                        <h6 v-if="(value === 'title')" class="subtitle is-6 has-text-weight-bold margin-top-25">{{node}}</h6>
                                        <h6 v-if="(value === 'sub_title' && branch !== 'additional_notifications')"
                                            class="subtitle is-7 margin-top-10 margin-bottom-10"
                                            v-html="`${node}`"></h6>
                                    </div>
                                </div>

                                <!--email notifications settings -->
                                <div v-if="(value === 'type' && tree.type === 'collection' && tree.form_element === 'radio')" class="column is-8-widescreen is-paddingless is-10-tablet">
                                    <label v-for="(radio, value) in tree.elements" class="radio is-size-7">
                                        <span>
                                            <input
                                                type="radio"
                                                @change="hasEmailNotificationChanged"
                                                v-model="form.email_notifications"
                                                :value="`${tree.elements_values[value]}`"
                                                :name="`${branch}`"
                                                >&nbsp;&nbsp;&nbsp;{{radio}}
                                        </span>
                                    </label>
                                </div>

                                <!--star ratings notifications settings-->
                                <div v-if="isPermitted" class="column is-8-widescreen is-paddingless is-10-tablet">
                                   <div v-if="(value === 'type' && tree.type === 'collection' && tree.form_element === 'checkbox')">
                                    <label v-for="(checkbox, value) in tree.elements" class="radio is-size-7">
                                        <span>
                                            <input
                                                type="checkbox"
                                                :ref="++value"
                                                @change="hasStarRatingNotificationChanged"
                                                v-model="form.star_rating_notifications['star_rating_' + value]"
                                                :name="`${branch}_${value}`"
                                                >&nbsp;&nbsp;&nbsp;{{checkbox}}
                                        </span>
                                    </label>
                                   </div>
                                </div>

                                <!--sms notifications settings-->
                                <div v-if="value === 'type' && tree.type === 'checkbox'"  class="column column is-8-widescreen is-paddingless is-10-tablet is-paddingless">
                                    <span v-if="branch === 'sms_settings' && isPermitted">
                                        <label v-if="has_mobile_number" class="label is-size-7 has-text-weight-normal">
                                            <input type="checkbox"
                                                   @change="hasSMSNotificationChanged($event)"
                                                   :name="`${branch}`"
                                                   v-model="form.receive_sms"
                                                   :value="`${form.receive_sms}`"> &nbsp;<span v-html="`${tree.element}`" ref="sms_info"></span>
                                        </label>
                                        <label v-else class="label is-size-7 has-text-weight-normal">
                                            We don't have a mobile number linked to your profile. <a href="#" class="has-text-underlined has-text-weight-bold" @click="renderMobileModal">Add one now</a>
                                        </label>
                                    </span>
                                    <span v-if="!isPermitted">
                                        <label class="label is-size-7 has-text-weight-normal">
                                            SMS notifications are only available on our <strong>Premium</strong>plan.
                                        </label>
                                    </span>
                                </div>

                                <!--additional email notifications settings-->
                                <div v-if="(value === 'type' && tree.type === 'modal_link')"  class="column column is-8-widescreen is-paddingless is-10-tablet is-paddingless">
                                    <span v-if="added_additional_emails" >
                                        <span v-for="(email,index) in added_additional_emails"  class="label is-size-7 has-text-weight-normal">
                                            <strong>{{email.value}}</strong> | <a href="#" class="has-text-underlined" @click.prevent="removeBusinessEmail(index, added_additional_emails[index].fieldName, email.value)">remove</a>
                                        </span>
                                    </span>
                                    <label v-if="isPermitted" class="label is-size-7 has-text-weight-normal">
                                        <a v-if="added_additional_emails.length < 3" href="#" class="has-text-underlined has-text-weight-bold" @click="renderAdditionalEmailModal">Add more email address now.</a>
                                    </label>
                                    <label v-else class="label is-size-7 has-text-weight-normal">
                                        Only available on our <strong>Premium</strong>plan.
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!--save button-->
                    <div class="has-text-left margin-top-20 column is-6-desktop is-paddingless">
                        <button
                                :disabled="somethingHasChanged"
                                :class="[{ 'is-loading': is_sending}, 'button is-button-blue is-button-large']">SAVE CHANGES</button>
                    </div>
                </form>
            </div>
        </div>
  </div>
</template>
<script>
  /* eslint-disable indent,no-new,no-undef,no-unused-expressions, no-useless-escape */
  import ApiResource from '../api/ApiResource'
  import NotificationsSettings from './../mixins/notifications-settings'

  export default {
    metaInfo: {
      title: 'Business Portal | Hellopeter - Your notifications'
    },
    mounted () {
      this.$gtm.trackEvent({
        event: 'pageLoad',
        virtualPageUrl: this.$router.currentRoute.path,
        virtualPageTitle: 'Your notifications'
      })
    },
    mixins: [NotificationsSettings],
    data () {
      return {
        added_additional_emails: [],
        missing_additional_emails: [],
        subscription_type_for_business: undefined,
        is_loading: false,
        is_sending: false,
        original_email_notifications: '',
        original_star_rating_notifications: {},
        original_receive_sms: 0,
        has_email_notifications_changed: false,
        has_receive_sms_changed: false,
        has_mobile_number: false,
        mobile_modal_props: {
          title: 'Add a mobile number',
          body: 'Please provide a valid South African mobile number to enable SMS notifications',
          btn_action_title: 'SAVE',
          show_btns: true,
          task: 'addMobileNumber',
          producer: {},
          form_element: {
            element: 'input',
            name: 'mobile_number',
            placeholder: 'Mobile number',
            value: '',
            error_msg: 'Mobile number is not valid.',
            validate_form: true
          }
        },
        additional_email_modal_props: {
          title: 'Add extra notifications',
          body: 'Add additional email addresses to be notified of all review information.',
          btn_action_title: 'SAVE',
          show_btns: true,
          task: 'addEmailAddress',
          producer: {},
          textInputFields: ''
        },
        remove_email_modal_props: {
          title: '',
          body: 'If you remove this email address, no email notifications will be sent going forward.',
          btn_action_title: 'YES, I\'M SURE',
          show_btns: true,
          task: 'removeEmailAddress',
          producer: {},
          setWidthAuto: true
        },
        mobile_number: '',
        email_address: '',
        form: new ApiResource({
          email_notifications: 'ALL_REVIEW_ACTIVITY',
          receive_sms: 0,
          star_rating_notifications: {
            star_rating_1: true,
            star_rating_2: true,
            star_rating_3: true,
            star_rating_4: true,
            star_rating_5: true
          }
        })
      }
    },
    computed: {
      disableBtn () {
        return this.sending || !this.has_changed
      },
      somethingHasChanged () {
        return !(this.is_sending || this.hasEmailNotificationChanged() || this.hasSMSNotificationChanged() || !this.hasStarRatingNotificationChanged())
      },
      isPermitted () {
        const allowedPlans = ['Pro', 'Enterprise', 'P1', 'P2', 'P3', 'P4']
        return allowedPlans.indexOf(this.subscription_type_for_business) !== -1
      }
    },
    created () {
      this.getMyNotifications()
      // listen for the processOps event emitted by the Modal component on behalf of the global event hub
      window.events.$on('addMobileNumber', this.addMobileNumberToProfile)
      window.events.$on('addEmailAddress', this.addAdditionalEmailToBusinessProfile)
      window.events.$on('removeEmailAddress', this.removeAdditionalEmailFromBusinessProfile)
    },
    methods: {
      /**
       * Removes an email address from business profile
       * @param {int} index index in additional email array to pluck
       * @param {string} field what email column name
       * @param {string} email email address to delete
       * @returns {void}
       */
      removeBusinessEmail (index, field, email) {
        // initialize event producer's props
        let producer = {}
        producer.index = index
        producer.email = field
        // initialize modal's props
        this.remove_email_modal_props.producer = producer
        this.remove_email_modal_props.title = 'Confirm removal of ' + email
        // fire off confirmation modal
        modal(this.remove_email_modal_props)
      },
      /**
       * Makes an api call to get the notifications settings for the business user.
       * @returns {void}
       */
      getMyNotifications () {
        this.is_loading = true
        let orgId = localStorage.getItem('org_id')
        new ApiResource({}).send(`/me/notifications?business=${orgId}`, {}, 'get')
          .then((response) => {
            this.subscription_type_for_business = response.business.business_subscription_type
            this.form.email_notifications = response.email_notifications
            this.original_email_notifications = response.email_notifications
            this.form.receive_sms = response.receive_sms
            this.original_receive_sms = response.receive_sms
            this.has_mobile_number = (response.mobile_number !== null && response.mobile_number !== '')
            if (this.isPermitted) {
              this.additional_notifications_form_elements[0].fields = response.business.missing_additional_emails
              this.missing_additional_emails = response.business.missing_additional_emails
              this.added_additional_emails = response.business.added_additional_emails
              this.additional_email_modal_props.textInputFields = this.additional_notifications_form_elements
              if (response.star_rating_notifications !== null) {
                this.form.star_rating_notifications = JSON.parse(response.star_rating_notifications)
                this.original_star_rating_notifications = JSON.parse(response.star_rating_notifications)
              }
            }
            this.is_loading = false
          })
      },
      /**
       * Makes an api call to update business user's notifications settings.
       * @returns {void}
       */
      submitForm () {
        this.is_sending = true
        new ApiResource({}).send(`/me/notifications`, {
          email_notifications: this.form.email_notifications,
          receive_sms: this.form.receive_sms,
          star_rating_notifications: JSON.stringify(this.form.star_rating_notifications),
          business_id: localStorage.getItem('org_id')
        }, 'patch')
          .then((response) => {
            this.form.email_notifications = response.email_notifications
            this.original_email_notifications = response.email_notifications
            this.form.receive_sms = response.receive_sms
            this.original_receive_sms = response.receive_sms
            this.form.star_rating_notifications = JSON.parse(response.star_rating_notifications)
            this.original_star_rating_notifications = JSON.parse(response.star_rating_notifications)
            flash('Your notification settings have been successfully updated.')
              dataLayer.push({
                  'userMessage': {
                      'messageType': 'success',
                      'messageName': 'Successfully updated notification settings on Notifications View',
                      'displayedMessage': 'Your notification settings have been successfully updated.'
                  }
              })
          })
          .catch((error) => {
            console.log(error)
            flash('An error occurred and your notifications settings couldn\'t be saved. Kindly try again later.', 'is-danger')
              dataLayer.push({
                  'userMessage': {
                      'messageType': 'error',
                      'messageName': 'Failed to update notification settings on Notifications View',
                      'displayedMessage': 'An error occurred and your notifications settings couldn\'t be saved. Kindly try again later.'
                  }
              })
          })
        this.is_sending = false
        this.has_email_notifications_changed = false
        this.has_receive_sms_changed = false
      },
      /**
       * Determines if email notifications has been changed
       * @returns {boolean}
       */
      hasEmailNotificationChanged () {
        if (this.form.email_notifications === this.original_email_notifications) {
          this.has_email_notifications_changed = false
          this.form.sms_settings = 0
        } else {
          this.has_email_notifications_changed = true
          this.form.sms_settings = 1
        }
        return this.has_email_notifications_changed
      },
      /**
       * Determines if star rating notifications has been changed
       * @returns {boolean}
       */
      hasStarRatingNotificationChanged () {
        if (!this.isPermitted) {
          return true
        }
        return JSON.stringify(this.form.star_rating_notifications) === JSON.stringify(this.original_star_rating_notifications)
      },
      /**
       * Determines if sms notifications has been changed
       * @param {event} event event
       * @returns {boolean}
       */
      hasSMSNotificationChanged (event) {
        if (event !== undefined) {
          this.form.receive_sms = event.target.checked ? 1 : 0
        }
        if (this.form.receive_sms === this.original_receive_sms) {
          this.has_receive_sms_changed = false
        } else {
          this.has_receive_sms_changed = true
        }
        return this.has_receive_sms_changed
      },
      /**
       * Renders mobile number modal
       * @returns {void}
       */
      renderMobileModal () {
        modal(this.mobile_modal_props)
      },
      /**
       * Renders additional email modal
       * @returns {void}
       */
      renderAdditionalEmailModal () {
        modal(this.additional_email_modal_props)
      },
      /**
       * Adds mobile number to profile
       * @param {object} props properties sent back from Modal
       * @returns {void}
       */
      addMobileNumberToProfile (props) {
        if (props.form_element !== undefined && props.form_element.name === 'mobile_number') {
          // save mobile to profile
          new ApiResource({}).send(`/me/add-mobile`, {mobile_number: props.form_element.value}, 'patch')
              .then((response) => {
                localStorage.setItem('mobile_number', response.mobile_number)
                this.$refs.sms_info.innerHTML = 'Send me sms notifications to <strong>' + response.mobile_number + '</strong>'
                this.notifications_settings[0].sms_settings.element = this.$refs.sms_info.innerHTML
                this.has_mobile_number = true
                this.form.receive_sms = true

                new ApiResource({}).send(`/me/notifications`, {
                  receive_sms: this.form.receive_sms,
                  business_id: localStorage.getItem('org_id')
                }, 'patch')
                  .then((response) => {
                    this.form.receive_sms = response.receive_sms
                    this.original_receive_sms = response.receive_sms
                  })

                this.hasSMSNotificationChanged()
                flash('Mobile number added to profile successfully.')
                  dataLayer.push({
                      'userMessage': {
                          'messageType': 'success',
                          'messageName': 'Successfully added mobile number in notification settings on Notifications View',
                          'displayedMessage': 'Mobile number added to profile successfully.'
                      }
                  })
              })
              .catch((error) => {
                console.log(error)
                flash(this.form.errors.getDefaultErrorMessage(), 'is-danger')
                  dataLayer.push({
                      'userMessage': {
                          'messageType': 'error',
                          'messageName': 'Failed to added mobile number in notification settings on Notifications View',
                          'displayedMessage': this.form.errors.getDefaultErrorMessage()
                      }
                  })
              })
        }
      },
      /**
       * Adds additional email addresses to business profile
       * @param {object} props properties sent back from Modal
       * @returns {void}
       */
      addAdditionalEmailToBusinessProfile (props) {
        // save additional email addresses to business
        let businessSlug = localStorage.getItem('org_slug')
        new ApiResource({}).send(`/business/${businessSlug}/add-additional-emails`, props)
              .then(() => {
                for (let fieldName in props) {
                  // update holders of what container that keep track of missing or added emails
                  if (props[fieldName] !== '') {
                    this.added_additional_emails.push({fieldName: fieldName, placeholder: 'Additional email', type: 'text', value: props[fieldName]})
                    this.missing_additional_emails.map((field, index) => {
                      if (field.fieldName === fieldName) {
                        this.missing_additional_emails.splice(index, 1)
                      }
                    })
                  }
                  // update mixin to have the most updated input fields that values are needed for to render on modal
                  this.additional_notifications_form_elements[0].fields = this.missing_additional_emails
                  this.additional_email_modal_props.textInputFields = this.additional_notifications_form_elements
                }
                flash('Additional email address was added successfully.')
                  dataLayer.push({
                      'userMessage': {
                          'messageType': 'success',
                          'messageName': 'Successfully added additional email in notification settings on Notifications View',
                          'displayedMessage': 'Additional email address was added successfully.'
                      }
                  })
              })
              .catch((error) => {
                flash(error.error, 'is-danger')
                  dataLayer.push({
                      'userMessage': {
                          'messageType': 'error',
                          'messageName': 'Failed to add an additional email in notification settings on Notifications View',
                          'displayedMessage': error.error
                      }
                  })
              })
      },
      /**
       * Removes an additional email addresses from business profile
       * @param {object} props properties sent back from Modal
       * @returns {void}
       */
      removeAdditionalEmailFromBusinessProfile (props) {
        if (props.task === 'removeEmailAddress') {
          let businessSlug = localStorage.getItem('org_slug')

          new ApiResource({}).send(`/business/${businessSlug}/delete-business-email`, {field: props.producer.email}, 'patch')
              .then(() => {
                // update holders of what container that keep track of missing or added emails
                this.added_additional_emails.splice(props.producer.index, 1)
                this.missing_additional_emails.push({fieldName: props.producer.email, placeholder: 'Additional email', type: 'text', value: ''})
                // update mixin to have the most updated input fields that values are needed for to render on modal
                this.additional_notifications_form_elements[0].fields = this.missing_additional_emails
                this.additional_email_modal_props.textInputFields = this.additional_notifications_form_elements
                flash('Additional email address was removed successfully.')
                  dataLayer.push({
                      'userMessage': {
                          'messageType': 'success',
                          'messageName': 'Successfully removed additional email in notification settings on Notifications View',
                          'displayedMessage': 'Additional email address was removed successfully.'
                      }
                  })
              })
              .catch((error) => {
                console.log(error)
                flash(this.form.errors.getDefaultErrorMessage(), 'is-danger')
                  dataLayer.push({
                      'userMessage': {
                          'messageType': 'error',
                          'messageName': 'Failed to remove additional email in notification settings on Notifications View',
                          'displayedMessage': this.form.errors.getDefaultErrorMessage()
                      }
                  })
              })
        }
      }
    }
  }
</script>
<style scoped>
label {
    display:block;
    margin-left: 0!important;
    padding: 7px 7px 7px 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/Notifications.vue